export default {
  "content": "\n<path d=\"M11.9516 2.5C12.5484 4.29032 13.4935 5.48387 15.5323 6.67742C17.5711 7.87097 19.7097 7.87097 20.9033 7.87097M15.5323 15.0323C15.5323 18.3282 12.8604 21 9.56454 21C6.26865 21 3.5968 18.3282 3.5968 15.0323C3.5968 11.7364 6.26865 9.06452 9.56454 9.06452C12.8604 9.06452 15.5323 11.7364 15.5323 15.0323Z\" stroke=\"currentColor\" stroke-width=\"2.3871\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};